module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search for name","clear":"Clear selected"},"pt-BR":{"search":"Pesquise pelo nome","clear":"Limpar selecionados"}}')
  delete Component.options._Ctor
}
